<script>
  export default {
    name: 'AdaValidatorIssueList',
    props: {
      rows: {
        type: Array,
        required: true
      },
      variant: {
        type: String,
        required: true,
        validator: v => v === 'empty' || v === 'missing'
      }
    },
    emits: ['select'],
    computed: {
      emptyMessage() {
        return this.variant === 'empty' ? 'No empty alt issues.' : 'No missing alt attribute issues.';
      },
      introText() {
        return this.variant === 'empty' ? "Please add alt text in Shopify's image editor for the following files." : 'Please submit a bug ticket for dev to address the following files.';
      }
    },
    methods: {
      onSelect(id) {
        this.$emit('select', id);
      }
    }
  };
</script>

<template>
  <div class="ada-validator-issue-list">
    <p v-if="rows.length === 0" class="ada-validator-tab-empty-msg">{{ emptyMessage }}</p>
    <template v-else>
      <p :class="{ 'ada-validator-please-add': variant === 'empty' }">{{ introText }}</p>
      <button v-for="row in rows" :key="row.id" type="button" class="ada-validator-row" @click.stop="onSelect(row.id)">
        <img class="ada-validator-thumb" :src="row.src" width="50" height="50" alt="" data-ada-validator-ignore="1" loading="lazy" decoding="async" />
        <div class="ada-validator-meta">
          <span
            >File: <span class="ada-validator-file-name">{{ row.fileName }}</span></span
          >
          <template v-if="variant === 'missing'">
            <span>Parent Element: {{ row.parentHint }}</span>
            <span>Section: {{ row.sectionHint }}</span>
          </template>
          <span class="ada-validator-hint">Click to scroll to section</span>
        </div>
      </button>
    </template>
  </div>
</template>

<style scoped>
  .ada-validator-issue-list {
    min-width: 0;
  }
  .ada-validator-tab-empty-msg {
    margin: 0 0 12px 0;
    opacity: 0.9;
  }
  .ada-validator-please-add,
  .ada-validator-tab-empty-msg {
    padding-left: 6px;
  }
  .ada-validator-row {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    min-width: 0;
    box-sizing: border-box;
    white-space: normal;
    text-align: left;
    cursor: pointer;
    padding: 20px;
    border-radius: 4px;
    margin: 0;
    border: none;
    background: transparent;
    color: inherit;
    font: inherit;
  }
  .ada-validator-row:hover {
    background: rgba(255, 255, 255, 0.12);
  }
  .ada-validator-thumb {
    width: 50px;
    height: 50px;
    object-fit: cover;
    flex-shrink: 0;
    border: 2px solid #fff;
  }
  .ada-validator-meta {
    flex: 1 1 0%;
    display: flex;
    flex-direction: column;
    gap: 7px;
    min-width: 0;
    align-items: stretch;
  }
  .ada-validator-meta > span {
    display: block;
    min-width: 0;
    overflow-wrap: anywhere;
  }
  .ada-validator-file-name {
    font-weight: 600;
  }
  .ada-validator-hint {
    font-size: 11px;
    font-weight: 600;
    opacity: 0.85;
  }
</style>
